import React from 'react';
import { Icon } from '@iconify/react';

const getTrendData = (current = 0, previous = 0) => {
    const diff = current - previous;
    const trend = diff >= 0 ? 'up' : 'down';
    return {
        trend,
        display: Math.abs(diff),
    };
};

const RidesStatesCard = ({ states }) => {
    const {
        total_bookings,
        old_total_bookings,
        total_kycbooking,
        old_total_kycbooking,
        total_ptbooking,
        old_total_ptbooking,
        total_wtsbooking,
        old_total_wtsbooking,
        other_bookings = {}, // ✅ NEW
    } = states || {};

    const totalRidesTrend = getTrendData(total_bookings, old_total_bookings);
    const kycRidesTrend = getTrendData(total_kycbooking, old_total_kycbooking);
    const ptRidesTrend = getTrendData(total_ptbooking, old_total_ptbooking);
    const wtsRidesTrend = getTrendData(total_wtsbooking, old_total_wtsbooking);

    return (
        <div className="row row-cols-xxxl-4 row-cols-lg-4 row-cols-sm-2 row-cols-1 gy-4 mb-24">

            {/* Static Cards (unchanged) */}
            <StatCard
                title="Total Rides"
                value={total_bookings}
                icon="mdi:car-multiple"
                iconBg="bg-cyan"
                bgClass="bg-gradient-start-1"
                trend={totalRidesTrend}
            />

            <StatCard
                title="WhatsApp Rides"
                value={total_wtsbooking}
                icon="ic:baseline-whatsapp"
                iconBg="bg-purple"
                bgClass="bg-gradient-start-2"
                trend={wtsRidesTrend}
            />

            <StatCard
                title="Partner Rides"
                value={total_ptbooking}
                icon="mdi:account-multiple"
                iconBg="bg-success-main"
                bgClass="bg-gradient-start-3"
                trend={ptRidesTrend}
            />

            <StatCard
                title="KYC Rides"
                value={total_kycbooking}
                icon="mdi:account-check-outline"
                iconBg="bg-info"
                bgClass="bg-gradient-start-4"
                trend={kycRidesTrend}
            />

            {/* ✅ Dynamic Other Booking Cards */}
            {Object.entries(other_bookings).map(([key, item], index) => {
                const trend = getTrendData(
                    item?.total_bookings,
                    item?.old_total_bookings
                );

                return (
                    <StatCard
                        key={key}
                        title={`${key.toUpperCase()} Rides`}
                        value={item?.total_bookings || 0}
                        icon="mdi:car-outline"
                        iconBg="bg-warning"
                        bgClass="bg-gradient-start-5"
                        trend={trend}
                    />
                );
            })}
        </div>
    );
};

const StatCard = ({ title, value, icon, iconBg, bgClass, trend }) => (
    <div className="col">
        <div className={`card shadow-none border ${bgClass} h-100`}>
            <div className="card-body p-20">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                    <div>
                        <p className="fw-medium text-primary-light mb-1">{title}</p>
                        <h6 className="mb-0">{value || 0}</h6>
                    </div>
                    <div className={`w-50-px h-50-px ${iconBg} rounded-circle d-flex justify-content-center align-items-center`}>
                        <Icon icon={icon} className="text-white text-2xl mb-0" />
                    </div>
                </div>
                <p className="fw-medium text-sm text-primary-light mt-12 mb-0 d-flex align-items-center gap-2">
                    <span className={`d-inline-flex align-items-center gap-1 ${trend.trend === 'up' ? 'text-success-main' : 'text-danger-main'
                        }`}>
                        <Icon icon={`bxs:${trend.trend}-arrow`} className="text-xs" />
                        {trend.trend === 'up' ? '+' : '-'}{trend.display}
                    </span>
                    vs last period
                </p>
            </div>
        </div>
    </div>
);

export default RidesStatesCard;